import { Controller, useForm } from "react-hook-form";
import { TextField, FormControl, Autocomplete } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Button from "../ui/Button";

const CommonFilter = ({
    config = [],
    defaultValues = {},
    onSubmit,
    onExport,
}) => {
    const { control, handleSubmit, reset, getValues } = useForm({
        defaultValues,
    });

    const handleExportClick = () => {
        const values = getValues();
        onExport && onExport(values);
    };

    const renderField = (field) => {
        switch (field.type) {
            case "text":
                return (
                    <Controller
                        name={field.name}
                        control={control}
                        render={({ field: input }) => (
                            <TextField
                                {...input}
                                label={field.label}
                                size="small"
                                fullWidth
                                onChange={(e) => {
                                    const value = e.target.value;
                                    input.onChange(value.trimStart());
                                }}
                                sx={{
                                    "& .MuiInputBase-root": {
                                        height: "40px",
                                    },
                                }}
                            />
                        )}
                    />
                );

            case "select":
                return (
                    <Controller
                        name={field.name}
                        control={control}
                        render={({ field: input }) => (
                            <FormControl fullWidth size="small">
                                <Autocomplete
                                    options={field.options || []}
                                    getOptionLabel={(opt) => opt.label || ""}
                                    value={
                                        field.options?.find(
                                            (o) => o.value === input.value
                                        ) || null
                                    }
                                    onChange={(e, val) =>
                                        input.onChange(val ? val.value : "")
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label={field.label}
                                            size="small"
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: "40px", // ✅ FIX HEIGHT
                                                },
                                                "& .MuiInputBase-input": {
                                                    padding: "10px 12px", // ✅ MATCH TEXTFIELD
                                                },
                                            }}
                                        />
                                    )}
                                />
                            </FormControl>
                        )}
                    />
                );

            case "autocomplete":
                return (
                    <Controller
                        name={field.name}
                        control={control}
                        render={({ field: input }) => (
                            <FormControl fullWidth size="small">
                                <Autocomplete
                                    options={field.options || []}
                                    getOptionLabel={(opt) =>
                                        opt[field.optionLabel] || ""
                                    }
                                    value={
                                        field.options?.find(
                                            (o) =>
                                                o[field.optionValue] === input.value
                                        ) || null
                                    }
                                    onChange={(e, val) =>
                                        input.onChange(
                                            val ? val[field.optionValue] : ""
                                        )
                                    }
                                    renderInput={(params) => (
                                        <TextField {...params} label={field.label} />
                                    )}
                                />
                            </FormControl>
                        )}
                    />
                );

            case "date":
                return (
                    <Controller
                        name={field.name}
                        control={control}
                        render={({ field: input }) => (
                            <DatePicker
                                label={field.label}
                                value={input.value || null}
                                onChange={input.onChange}
                                format="dd MMM yyyy"
                                slotProps={{
                                    textField: {
                                        size: "small",
                                        fullWidth: true,
                                        sx: {
                                            backgroundColor: "white",
                                            "& .MuiInputBase-root": {
                                                height: "40px", // ✅ FIX HEIGHT
                                            },
                                            "& .MuiInputBase-input": {
                                                padding: "10px 12px", // ✅ MATCH TEXTFIELD
                                            },
                                        },
                                    },
                                }}
                            />
                        )}
                    />
                );

            default:
                return null;
        }
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row g-2 align-items-end">

                {/* 🔹 Dynamic Fields */}
                {config.map((field) => (
                    <div
                        key={field.name}
                        className={`col-lg-${field.grid || 3} col-md-4 col-sm-6 col-12`}
                    >
                        {renderField(field)}
                    </div>
                ))}

                {/* 🔥 Buttons */}
                <div className="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div className="d-flex flex-wrap gap-2">
                        <Button type="submit" variant="success">
                            Filter
                        </Button>

                        <Button
                            type="button"
                            variant="dark"
                            onClick={() => {
                                reset();
                                onSubmit({});
                            }}
                        >
                            Clear
                        </Button>

                        {onExport && (
                            <Button
                                type="button"
                                variant="dark"
                                onClick={handleExportClick}
                            >
                                Export
                            </Button>
                        )}
                    </div>
                </div>

            </div>
        </form>
    );
};

export default CommonFilter;